import { visibilityProperties } from '@stilingue/visibility';
import authentication from '@stilingue/authentication';

const MINUTE_IN_MILLIS = 1000 * 60;
const auth = authentication();

export default class StWcFeedback extends HTMLElement {
  constructor() {
    super();
    this._shadow = this.attachShadow({ mode: 'open' });
    this._template = document.createElement('div');
    this._template.style.position = 'fixed';
    this._template.classList.add('auth-feedback-container');
    this._shadow.appendChild(this._template);
  }

  _startAuthTimer(t) {
    setTimeout(() => {
      if (this.active && !this.authenticated) {
        window.location.pathname = `/login?np_red=${encodeURIComponent(window.location.href)}`;
      }
    }, t);
  }

  get text() {
    return this.getAttribute('text') || '';
  }

  set text(t) {
    this.setAttribute('text', t);
  }

  get linkLabel() {
    return this.getAttribute('linkLabel') || '';
  }

  set linkLabel(l) {
    this.setAttribute('linkLabel', l);
  }

  get linkUrl() {
    return this.getAttribute('linkUrl') || '';
  }

  set linkUrl(url) {
    this.setAttribute('linkUrl', url);
  }

  get authenticated() {
    return this.getAttribute('authenticated') === null ? null : true;
  }

  set authenticated(value) {
    if (value === null || !this.active) {
      this.removeAttribute('authenticated');
      return;
    }
    this.setAttribute('authenticated', '');
    this.text = 'Sessão atualizada';
    this._render();
    this._shadow.getElementById('wc-link').classList.add('disabled');

    setTimeout(() => {
      this.active = null;
    }, 2000);
  }

  get active() {
    return this.getAttribute('active') === null ? null : true;
  }

  set active(value) {
    if (value === null) {
      this.removeAttribute('active');
    } else {
      auth.removeSessionId();
      this.text =
        'Sua sessão expirou. Você precisa refazer seu login agora ou será redirecionado automaticamente em alguns instantes';
      this.linkLabel = 'Refazer login';
      this.linkUrl = `/login?np_red=${encodeURIComponent(window.location.href)}`;
      this.setAttribute('active', '');
    }
    this._render();
  }

  async connectedCallback() {
    this.active = true;
    document.addEventListener(visibilityProperties.eventName, () => {
      if (!this.active || document.visibilityState !== visibilityProperties.visible) {
        return;
      }

      const sessionToken = auth.getSessionId();
      if (sessionToken) {
        this.authenticated = true;
      }
    });
    this._startAuthTimer(5 * MINUTE_IN_MILLIS);
  }

  /* eslint-disable complexity */
  _html() {
    return `
    <style>
      p {
        color: #212224;
        max-width: 80%;
        text-align: center;
        font-size: 12px;
        font-weight: 400;
        font-family: Open Sans;
      }
      a {
        font-weight: 600;
        align-self: center;
        font-size: 12px;
        margin: 0.3em;
        border-radius: 0.4em;
        padding: 0.4em;
        color: #212224;
      }

      a.disabled {
        display: none;
      }

      .auth-feedback-container {
        z-index: 5005;
        border-radius: 0.4em;
        ${this.active ? '' : 'display: none;'}
        top: 10px;
        left: ${this.authenticated ? 'calc(50% - 100px)' : 'calc(50% - 300px)'};
        width: ${this.authenticated ? '200px' : '600px;'};
        height: ${this.authenticated ? '50px' : '60px'};
        background: ${this.authenticated ? '#E6FEED' : '#FFDDE0'};
      }
      .auth-feedback-message {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        ${this.authenticated ? 'margin: 0.3em;' : ''}
      }
    </style>
    <div class="auth-feedback-message">
      <p>${this.text}</p>
      <a href="${this.linkUrl}" target="_blank" id="wc-link"> ${this.linkLabel}</a>
    </div>
  `;
  }

  async _render() {
    this._template.innerHTML = this._html();
  }
}
